// Update URL hash on tab change via event delegation — no timing dependency.
document.addEventListener('shown.bs.tab', (e) => {
  const hash = e.target.dataset.hash;

  if (hash) {
    history.replaceState(null, '', '#' + hash);
  }
});

// Activate tab from URL hash only after all scripts (including deferred Bootstrap) are ready.
window.addEventListener('load', () => {
  const hash = window.location.hash.replace('#', '');

  if (!hash) {
    return;
  }

  const btn = document.querySelector(`[data-hash="${hash}"]`);

  if (btn) {
    btn.click();
  }
});
